module.exports = __webpack_public_path__ + "img/vip_title.e7b63933.png";